import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import useDisableTrackingContext from './useDisableTrackingContext';

export default function useDisableTrackingsExceptGA() {
  const searchParams = useSearchParams();
  const { toggleValidatedTrackingState } = useDisableTrackingContext();
  const disableAllExceptGoogleAnalytics = searchParams?.get('ditra') === 'true';
  useEffect(() => {
    toggleValidatedTrackingState();
  }, [toggleValidatedTrackingState]);
  return { disableAllExceptGoogleAnalytics };
}
